import { MapTo } from '@adobe/aem-react-editable-components';
import ApplicationHeading, { ApplicationHeadingEditConfig } from './ApplicationHeading';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/application-heading',
)(ApplicationHeading, ApplicationHeadingEditConfig);